'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var type = require('../slider/v1/type.js');

const DEFAULT_PRODUCT_LIST = {
  layout: "grid",
  currencyUnit: "\u0111",
  currencyAlignment: "right",
  gridOptions: {
    rows: 4,
    columns: 4
  },
  items: [
    {
      name: "S\u1EA3n ph\u1EA9m 1",
      price: 1e5,
      link: "https://tempi.vn",
      discount: 30,
      image: {
        src: "https://lh3.googleusercontent.com/8uLsW5MRqfvFIpoVhchpQN6CuMdj0hXZV7dOplezAJ6j6RSdymfMCNstJMhs_G8QNZaNwh60gAhFrjYfZr2wG4JmnKfwGDw=rw-w500"
      },
      virtualRating: 5
    },
    {
      name: "S\u1EA3n ph\u1EA9m 2",
      price: 1e5,
      discount: 30,
      image: {
        src: "https://lh3.googleusercontent.com/s30ROB2cqLL_G97fr4qG8VjryAdAREIOV2pUSjq9p0IjXy8V7Jy3hf-E1f-wtA9t69JIbg4xSyNR3ck_Jnfpn4bfZ6rSmJNg=rw-w500"
      },
      virtualRating: 5
    },
    {
      name: "S\u1EA3n ph\u1EA9m 3",
      price: 1e5,
      discount: 30,
      image: {
        src: "https://lh3.googleusercontent.com/tQK0m1oxjAfQGKzSn1iDGLCZBKsalp3FFj8Jw89pYH5IVQLhq9UiKrq774Q1-JkQ5hyR5xhUvnApUEmR-YzOMpJkNpnk3IuH=rw-w500"
      },
      virtualRating: 5
    },
    {
      name: "S\u1EA3n ph\u1EA9m 4",
      price: 1e5,
      discount: 30,
      image: {
        src: "https://lh3.googleusercontent.com/xR9Sx8XT-vsY7F-2x4wnlGk7LXFLb2sCW1RoWtR7dTUmfrpqVvdO2F00Q8g51s7b1TYVZddlIIQXoUzRiv50Ao4k3TLQbvY=rw-w500"
      },
      virtualRating: 5
    }
  ],
  eventType: "link",
  alignment: "left",
  nameStyle: {
    color: "#000",
    fontSize: 16
  },
  priceStyle: {
    color: "#000",
    fontSize: 14
  }
};
const defaultGridOptions = {
  rows: 1,
  columns: 4
};
const defaultCarouselOptions = {
  type: type.SliderTypeEnum.product,
  slidesPerView: 5,
  slidesPerColumn: 1,
  navigation: true,
  navigationStyle: 1,
  autoplay: true,
  loop: false,
  spaceBetween: 16,
  speed: 3e3
};
const DATA_KEYS = {
  name: "T\xEAn kh\xE1ch h\xE0ng",
  phoneNumber: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
  address: "\u0110\u1ECBa ch\u1EC9",
  note: "Th\xF4ng tin b\u1ED5 sung",
  productName: "T\xEAn s\u1EA3n ph\u1EA9m",
  price: "Gi\xE1 b\xE1n"
};
const inputsConfig = [
  {
    type: "text",
    name: DATA_KEYS.name,
    label: "T\xEAn",
    placeholder: "Nh\u1EADp h\u1ECD v\xE0 t\xEAn",
    required: true,
    commonStyle: {
      height: 32,
      width: "100%"
    },
    inputStyle: {
      borderRadius: 4
    }
  },
  {
    type: "tel",
    name: DATA_KEYS.phoneNumber,
    label: "S\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
    placeholder: "Nh\u1EADp s\u1ED1 \u0111i\u1EC7n tho\u1EA1i",
    required: true,
    commonStyle: {
      height: 32,
      width: "100%"
    },
    inputStyle: {
      borderRadius: 4
    }
  },
  {
    type: "text",
    name: DATA_KEYS.address,
    label: "\u0110\u1ECBa ch\u1EC9",
    placeholder: "Nh\u1EADp \u0111\u1ECBa ch\u1EC9 nh\u1EADn h\xE0ng",
    required: true,
    commonStyle: {
      height: 32,
      width: "100%"
    },
    inputStyle: {
      borderRadius: 4
    }
  },
  {
    type: "textarea",
    name: DATA_KEYS.note,
    label: "Th\xF4ng tin b\u1ED5 sung",
    placeholder: "Th\xF4ng tin b\u1ED5 sung cho ng\u01B0\u1EDDi b\xE1n.\nVD: S\u1ED1 l\u01B0\u1EE3ng, k\xEDch th\u01B0\u1EDBc, giao gi\u1EDD h\xE0nh ch\xEDnh...",
    commonStyle: {
      width: "100%"
    },
    inputStyle: {
      borderRadius: 4,
      minHeight: 100
    }
  }
];

exports.DATA_KEYS = DATA_KEYS;
exports.DEFAULT_PRODUCT_LIST = DEFAULT_PRODUCT_LIST;
exports.defaultCarouselOptions = defaultCarouselOptions;
exports.defaultGridOptions = defaultGridOptions;
exports.inputsConfig = inputsConfig;
